import React from 'react';

const ImageDisplay = ({ title, imageSrc, imageSize }) => {
    return (
        <div className="image-display">
            <h3>{title}</h3>
            <img src={imageSrc} alt={title} />
            <b>Size: {imageSize} KB</b>
        </div>
    );
};

export default ImageDisplay;
